var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ig"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "yt"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "snapchat"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "WA"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,63c-0.3,0-0.5-0.1-0.7-0.3c-0.3-0.3-0.4-0.7-0.2-1l4.5-13.6C2.6,43.3,1,37.7,1,32C1,14.9,14.9,1,32,1s31,13.9,31,31     S49.1,63,32,63c-5.7,0-11.3-1.6-16.1-4.5L2.3,62.9C2.2,63,2.1,63,2,63z M16,56.4c0.2,0,0.4,0.1,0.5,0.2c4.6,2.9,10,4.5,15.5,4.5     c16,0,29-13,29-29S48,3,32,3S3,16,3,32c0,5.5,1.6,10.9,4.5,15.5c0.2,0.3,0.2,0.6,0.1,0.8c0,0.1-0.1,0.2-0.2,0.3L3.6,60.4l12.1-4     C15.8,56.4,15.9,56.4,16,56.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40,47.3c-2.7,0-6.1-0.9-10-2.7c-5.4-2.5-9.8-6.4-12.7-11.3c-1.7-2.8-2.6-5.4-2.7-7.8c0-0.1-0.5-4.7,3.9-8.2     c0.5-0.4,1.1-0.6,1.8-0.6l1.8,0c1.1,0,2.2,0.7,2.6,1.7l2.7,6.6c0.4,1,0.2,2.2-0.5,3l-1.7,1.9c-0.2,0.3-0.3,0.7-0.1,1     c0.1,0.1,0.2,0.4,0.6,0.9c2,2.6,4.7,4.7,7.7,6c0.5,0.2,0.8,0.3,1,0.4c0.3,0.1,0.7,0,0.9-0.3l1.4-2.1c0.6-0.9,1.7-1.4,2.8-1.2     l7.1,1.1c1.1,0.2,2,1,2.3,2.1l0.4,1.8c0.2,0.6,0.1,1.3-0.2,1.9c0,0,0,0,0,0c-2.4,5.2-6.9,5.8-7.1,5.8     C41.4,47.2,40.7,47.3,40,47.3z M20.3,18.7c-0.2,0-0.4,0.1-0.5,0.2c-3.6,2.9-3.2,6.5-3.2,6.5c0.1,2.1,0.9,4.4,2.4,6.9     c2.7,4.5,6.8,8.2,11.8,10.5c4.5,2.1,8.2,2.9,10.9,2.4c0.2,0,3.7-0.6,5.6-4.7c0.1-0.2,0.1-0.4,0-0.5L47,38.2     c-0.1-0.3-0.3-0.6-0.7-0.6l-7.1-1.1c-0.3,0-0.6,0.1-0.8,0.4L37,39c-0.7,1-1.9,1.5-3.1,1.2c-0.3-0.1-0.7-0.2-1.3-0.5     c-3.3-1.5-6.3-3.8-8.5-6.7c-0.4-0.5-0.6-0.8-0.8-1.1c-0.6-1.1-0.4-2.4,0.4-3.3l1.7-1.9c0.2-0.2,0.3-0.6,0.2-0.9l-2.7-6.6     c-0.1-0.3-0.4-0.5-0.8-0.5L20.3,18.7C20.3,18.7,20.3,18.7,20.3,18.7z M48.3,40.9L48.3,40.9L48.3,40.9z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Pinterrest"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Messenger"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Tiktok"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "VK"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Thumblr"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "OK.ru"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Weibo"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatapp);
export default __webpack_public_path__ + "static/media/whatapp.11628460.svg";
export { ForwardRef as ReactComponent };